export interface ImageContext {
	// Route production asset URLs through the same-origin /_proxyAssets proxy rather
	// than the cross-origin production host. Needed wherever the poster is rendered
	// to a canvas while showing production images (e.g. the admin design page): a
	// cross-origin URL can be displayed but not fetched/inlined for the JPEG export.
	proxyProductionAssets: boolean
}

export function createImageState(proxyProductionAssets: boolean): ImageContext {
	return { proxyProductionAssets }
}
